import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { immer } from 'zustand/middleware/immer';
import { persist } from 'zustand/middleware'

export interface AthenaMenuStore {
	activeTab: string;
	/**
	 * 設定選中的 Tab
	 * @param tab 請使用 athenaMenuService.getTabIdentifier 產生的識別符
	 */
	setActiveTab: (tab: string) => void;
}

type AthenaMenuStoreKey = keyof AthenaMenuStore;

export const useAthenaMenuStore = createWithEqualityFn<AthenaMenuStore, [['zustand/persist', AthenaMenuStore], ['zustand/immer', never]]>(
	persist(immer<AthenaMenuStore>((set, get) => ({
		activeTab: '',
		setActiveTab: (tab: string) => {
			set({ activeTab: tab });
		},
	})), {
		name: 'athena-menu-store-storage',
		/**
		 * add SiteStore key to keep data in browser storage, prevent data missing after refresh
		 */
		partialize: (state) => Object.fromEntries(
			Object.entries(state).filter(([key]) => ([
				'activeTab',
			] as AthenaMenuStoreKey[]).includes(key as AthenaMenuStoreKey))
		) as AthenaMenuStore,
	}),
	shallow
);